/**
 * Labstep
 *
 * @module screens/VerifyEmail
 * @desc Verify Email Screen
 */

import { FullScreenPage as LayoutFullScreenPage } from 'labstep-web/components/Layout/FullScreenPage';
import { DocumentHead } from 'labstep-web/core/DocumentHead';
import type React from 'react';
import Center from './Center';
import type { IVerifyEmailScreenProps } from './types';

export const VerifyEmailScreen: React.FC<IVerifyEmailScreenProps> = ({
  match,
}) => (
  <>
    <DocumentHead title="Verify Email" />
    <LayoutFullScreenPage>
      <Center match={match} />
    </LayoutFullScreenPage>
  </>
);
